import { render, staticRenderFns } from "./PortalWindow.vue?vue&type=template&id=6beeed41"
import script from "./PortalWindow.vue?vue&type=script&lang=js"
export * from "./PortalWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports